module.exports = __webpack_public_path__ + "SD.png?38ae49bb5ceebe6f149452be89b78c0d";